export default {"src":"/_next/static/media/right_arrow_black.1ff2a07d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};